import { toast, ToastPosition, TypeOptions } from 'react-toastify';

const toastHelper = {
  show: (msg: string, type: TypeOptions = 'success', timer?: number | false) => {
    toast(msg, { type, autoClose: timer, delay: 0 });
  },
  showSuccess: (msg: string | any, timer?: number | false) => {
    toastHelper.show(msg, 'success', timer);
  },
  showWarning: (msg: string | any, timer?: number | false) => {
    toastHelper.show(msg, 'warning', timer);
  },
  showInfo: (msg: string | any, timer?: number | false) => {
    toastHelper.show(msg, 'info', timer);
  },
  showError: (msg: string | any = 'Lỗi không thể xử lý', timer?: number | false) => {
    toastHelper.show(msg, 'error', timer);
  },
  showMsgCenter: (msg: string, type: TypeOptions = 'success') => {
    toast(msg, { type, autoClose: 5000, delay: 0, position: 'top-center' });
  },
  showMsgPosition: (msg: string, type: TypeOptions = 'success', position: ToastPosition) => {
    toast(msg, { type, autoClose: 5000, delay: 0, position: position });
  }
};
export default toastHelper;
